export default __webpack_public_path__ + "static/media/AiCPA.bb804ea6.png";